import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, MenuItem, Typography } from '@mui/material'
import { styled } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { RouteImage } from '../../../assets/routeImage'
import moment, { Moment } from 'moment'
import { saveAs } from 'file-saver'
import useMediaQuery from '@mui/material/useMediaQuery';

// COMPONENT
// import { ButtonOutlined } from '../../../component/mui-custom/MuiCustom'
import Header from '../Header'
import Navbar from '../Navbar'
import * as styles from '../style/main.style'
import InputTextField from '../../../component/input/inputTextField'
import FilterSelect from '../../../component/select/filterSelect'
import SearchAutocompleteSelect from '../../../component/select/searchAutocompleteSelect'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import TableRowCommon from '../../../component/table/TableRowCommon'
import TableCustom from '../../../component/table/tableCustom'
import RangeCustom from '../../../component/ranges/RangeCustom'
import { ProjectApi, getProject } from '../../../api/project/project.api'
import { FiscalYearApi } from '../../../api/fiscal-year/fiscalyear.api'
import { debouncedApiCall } from '../../../utils/app.utils'
import { DepartMentApi } from '../../../api/department/department.api'
import { StrategyApi } from '../../../api/strategy/strategy.api'
import { TacticsApi } from '../../../api/tactics/tactics.api'
import { PlanApi } from '../../../api/plan/plan.api'
import { TypesApi } from '../../../api/type/type.api'
import { ClustersApi } from '../../../api/clusters/clusters.api'
import { BudgetApi } from '../../../api/budget/budget.api'
import { useDispatch, useSelector } from 'react-redux'
import Loading from '../../../component/loading/Loading'
import { setLoading, unsetLoading } from '../../../store/slice/loading/loading.slice'
import MenuDropdown from '../../../component/menu-dropdown/MenuDropdown'
import { setPageTrackingLimitStore, setPageTrackingStore } from '../../../store/slice/pagination/pagination.slice'
import UpdateIcon from '@mui/icons-material/Update';

const FilterBox = styled('section')({
    width: "100%",
    height: "auto",
})

const TrackProjectStatus: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const matches = useMediaQuery('(min-width:600px)');
    const isLoading = useSelector((state: any) => state?.loading?.isLoading)
    const permission = useSelector((state: any) => state?.permission?.permission)
    const pageLimitTrackingStore: number = useSelector((state: any) => state?.pagination?.pageLimitTracking);
    const pageTrackingStore: number = useSelector((state: any) => state?.pagination?.pageTracking);

    // const [page, setPage] = useState<number>(1);
    // const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalPage, setTotalPage] = useState<number>(Number);
    const [keyword, setKeyword] = useState<string>("");
    const [tracking, setTracking] = useState<any[]>([]);
    const [projectStatus, setProjectStatus] = useState<any[]>([]);

    const [idFiscalYear, setIdFiscalYear] = useState<number>(Number);
    const [idDepartment, setIdDepartment] = useState<number>(Number);
    const [idStrategy, setIdStrategy] = useState<number>(Number);
    const [idTactics, setIdTactics] = useState<number>(Number);
    const [idPlan, setIdPlan] = useState<number>(Number);
    const [idType, setIdType] = useState<number>(Number);
    const [idClusters, setIdClusters] = useState<number>(Number);
    const [idBudget, setIdBudget] = useState<number>(Number);
    const [idStatus, setIdStatus] = useState<number>(Number);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC")

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const handleChangeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(setPageTrackingStore(1));
        debouncedApiCall({ searchItem: event.target.value, setItem: setKeyword })
    }

    const headCells = [
        {
            id: "is_extended", disablePadding: false, width: 30, align: 'center', label: ""
        },
        {
            id: "idProject", disablePadding: false, width: 90, align: 'center', label: "ลำดับ"
        },
        {
            id: "PROJECT", disablePadding: false, width: 600, align: "center", label: "โครงการ"
        },
        {
            id: "idFiscalYear", disablePadding: false, width: 100, align: "center", sortable: true, label: "ปีงบประมาณ"
        },
        {
            id: "sumAllBudget", disablePadding: false, width: 200, align: "center", sortable: true, label: "งบประมาณ"

        },
        {
            id: "sumAllPaid", disablePadding: false, width: 170, sortable: true, align: "center", label: "งบเบิกจ่าย"

        },
        {
            id: "WORK_PERIOD", disablePadding: false, align: "center", width: 170, label: "งวดงาน"

        },
        {
            id: "DATE", disablePadding: false, align: "center", width: 300, label: "ระยะเวลาโครงการ"

        },
        {
            id: "AGENCY", disablePadding: false, width: 240, align: "center", label: "หน่วยงาน"

        },
        {
            id: "STATUS",
            class: matches ? true : false,
            disablePadding: true,
            width: 330,
            align: "center", label: "สถานะ"

        },
    ];

    const renderData = (objData: any, no: any) => {
        no = pageTrackingStore * pageLimitTrackingStore - pageLimitTrackingStore + no + 1
        const { projectName, idProject, is_extended, statusPercent, idFiscalYear, sumAllPaid, periodCount, departmentName, sumAllBudget, projectStartDate, projectEndDate, statusName, percentageName } =
            objData;


        const diffInDays = moment(projectEndDate).diff(projectStartDate, 'days');
        const diffInMonths = moment(projectEndDate).diff(projectStartDate, 'months') % 12;
        const diffInYears = moment(projectEndDate).diff(projectStartDate, 'years');

        let diffString;
        if (diffInYears > 0) {
            diffString = `${diffInYears} ปี${diffInYears > 1 ? '' : ''}`;
            if (diffInMonths > 0) {
                diffString += ` ${diffInMonths} เดือน${diffInMonths > 1 ? '' : ''}`;
            }
        } else if (diffInMonths > 0) {
            diffString = `${diffInMonths} เดือน${diffInMonths > 1 ? '' : ''}`;
        } else {
            diffString = `${diffInDays} วัน${diffInDays > 1 ? '' : ''}`;
        }

        const today: Moment = moment(new Date());
        const todayToEndDate = moment(projectEndDate).diff(today, 'days')

        const percentDate = (todayToEndDate / diffInDays) * 100;


        function handlePercentCheck(percent: number): string {
            // วันที่ปัจจุบัน เกินวันที่สิ้นสุด
            if (todayToEndDate < 0 && percent === 100 || todayToEndDate < 0 && percent === null) {
                return '#98d44c'
            } else if (todayToEndDate < 0 && percent < 100) {
                return '#ff0404'
            } else if (todayToEndDate > 0 && percent === 100) {
                return '#98d44c'
            } else if (todayToEndDate > 0 && percentDate > 25 && percent < 100) {
                return '#a0c4e4'
            } else if (todayToEndDate > 0 && percentDate <= 25 && percent < 100) {
                return '#fffc04'
            }
            return '#1976d2'
        }
        let colorPercentCount: string = handlePercentCheck(statusPercent);



        const percentStatus: number = Number(statusPercent) || 0;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                {
                    // option: "TEXT", align: "center", label: is_extended ? <UpdateIcon /> : ""
                    option: "TEXT", align: "center", label: +is_extended ? <Box pl={3} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                        <UpdateIcon sx={{ color: "#eb9615" }} />
                    </Box> : ""
                },
                {
                    option: "TEXT", align: "center", label: no || "-"
                },
                {
                    option: "TEXT", align: "left", label: projectName || "-",
                },
                {
                    option: "TEXT", align: "right", label: idFiscalYear || 0,
                },
                {
                    option: "PRICE", align: "right", label: sumAllBudget || 0,
                },
                {
                    option: "PRICE", align: "right", label: sumAllPaid || 0,
                },
                {
                    option: "TEXT", align: "center", label: `${periodCount} งวด` || "-",
                },
                {
                    option: "TEXT", align: "center", label: `${moment(projectStartDate).format("DD/MM/YYYY")} - ${moment(projectEndDate).format("DD/MM/YYYY")}  (${diffString})` || "-",
                },
                {
                    option: "TEXT", align: "left", label: departmentName || "-",
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches ? true : false,
                    component: (
                        <div className='w-full flex flex-col md:flex-row gap-y-3 gap-x-4'>
                            <span className='text-base_secondary flex items-start flex-col mt-4 w-full'>
                                <RangeCustom color={colorPercentCount} num={percentStatus} />
                                <span>
                                    <Typography variant='subtitle1'>
                                        {<li className='list-item leading-[desired-line-height] text-base_disable'>
                                            {statusName}
                                        </li>}
                                    </Typography>
                                </span>
                            </span>
                            <span className='flex justify-center items-center gap-x-3'>
                                {permission?.find((list: any) => list?.code === "ProjectStatus.Read")?.permit === true && (
                                    <RemoveRedEyeOutlinedIcon
                                        onClick={() => navigate('/auth/project-status/view', { state: idProject })}
                                        className='text-base_disable cursor-pointer'
                                    />
                                )}
                                {permission?.find((list: any) => list?.code === "ProjectStatus.Edit")?.permit === true && (
                                    <button onClick={() => navigate(`/auth/project-status/edit/${idProject}`, { state: idProject })}>
                                        <img src={RouteImage.editIcon} style={{ maxWidth: 24 }} alt='icons' />
                                    </button>
                                )}
                                {/* {permission?.find((list: any) => list?.code === "ProjectStatus.Delete")?.permit === true && (
                                    <button
                                        onClick={() => {
                                            Swal.fire({
                                                title: "คุณต้องการลบโครงการ?",
                                                animation: true,
                                                showCancelButton: true,
                                                allowEnterKey: true,
                                                confirmButtonColor: colors.themeMainColor,
                                                cancelButtonColor: colors.danger,
                                                cancelButtonText: t("BUTTON.CANCEL"),
                                                showClass: {
                                                    popup: `
                                                      animate__animated
                                                      animate__fadeInUp
                                                      animate__faster
                                                    `
                                                },
                                                hideClass: {
                                                    popup: `
                                                      animate__animated
                                                      animate__fadeOutDown
                                                      animate__faster
                                                    `
                                                },
                                                confirmButtonText: "ลบโครงการ",
                                            }).then(async (result) => {
                                                if (result.isConfirmed) {
                                                    await handleDeleteProject(idProject)
                                                    Swal.fire("บันทึกข้อมูลเรียบร้อย", "", "success");
                                                } else {

                                                }
                                            });

                                        }}
                                    >
                                        <img src={RouteImage.delete} style={{ maxWidth: 24 }} alt='icons' />
                                    </button>
                                )} */}
                            </span>
                        </div >
                    ),
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleGetProjectStatus = useCallback(async () => {
        let condition: any = {}
        if (idType !== 0) condition = { ...condition, idType: idType }
        await ProjectApi.getProjectStatus(condition)
            .then(res => {
                if (res.status === 200) {
                    setProjectStatus(res.data?.result)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [idType])


    const handleGetTrackingProjectFile = useCallback(async (format: 'pdf' | 'excel') => {
        dispatch(setLoading())
        let condition: getProject = {
            format: format
        }
        if (sortBy) condition = { ...condition, sortBy: sortBy }
        if (sortType) condition = { ...condition, sortType: sortType }
        if (keyword) condition = { ...condition, keyword: keyword }
        if (idStatus) condition = { ...condition, idStatus: idStatus }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        if (idDepartment) condition = { ...condition, idDepartment: idDepartment }
        if (idStrategy) condition = { ...condition, idStrategy: idStrategy }
        if (idTactics) condition = { ...condition, idTactics: idTactics }
        if (idPlan) condition = { ...condition, idPlan: idPlan }
        if (idClusters) condition = { ...condition, idClusters: idClusters }
        if (idBudget) condition = { ...condition, idBudget: idBudget }
        if (idType) condition = { ...condition, idType: idType }
        if (idStatus) condition = { ...condition, idStatus: idStatus }
        // if (endDate) condition = { ...condition, endDate: endDate }
        await ProjectApi.excelExportTracking(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    const data = res?.data
                    if (format === 'pdf') {
                        const blob = new Blob([data], { type: 'application/pdf' });
                        saveAs(blob, 'project-pdf-e-monitering');
                    } else if (format === 'excel') {
                        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        saveAs(blob, 'project-xlsx-e-monitering');
                    }
                }
            })
            .catch(error => console.log(error))
            .finally(() => dispatch(unsetLoading()))
    }, [keyword, sortBy, sortType, idDepartment, idStrategy, idTactics, idPlan, idClusters, idBudget, idStatus, idType, idFiscalYear])

    const handleGetTrackingProject = useCallback(async () => {
        dispatch(setLoading())
        let condition: getProject = {
            sortBy: sortBy,
            sortType: sortType
        }
        if (pageTrackingStore) condition = { ...condition, page: pageTrackingStore }
        if (pageLimitTrackingStore) condition = { ...condition, limit: pageLimitTrackingStore }
        if (keyword) condition = { ...condition, keyword: keyword }
        if (idFiscalYear !== 0) condition = { ...condition, idFiscalYear: idFiscalYear }
        if (idDepartment) condition = { ...condition, idDepartment: idDepartment }
        if (idStrategy) condition = { ...condition, idStrategy: idStrategy }
        if (idTactics) condition = { ...condition, idTactics: idTactics }
        if (idPlan) condition = { ...condition, idPlan: idPlan }
        if (idType) condition = { ...condition, idType: idType }
        if (idClusters) condition = { ...condition, idClusters: idClusters }
        if (idBudget) condition = { ...condition, idBudget: idBudget }
        if (idStatus) condition = { ...condition, idStatus: idStatus }

        await ProjectApi.getTrackingProject(condition)
            .then(res => {
                dispatch(unsetLoading())
                setTracking(res.data?.result?.items)
                setTotalPage(res.data?.result?.meta?.totalItems)
                // console.log(res.data?.result?.items)
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }, [idFiscalYear, sortBy, sortType, pageTrackingStore, pageLimitTrackingStore, keyword, idDepartment, idStrategy, idTactics, idPlan, idType, idClusters, idBudget, idStatus])

    useEffect(() => {
        handleGetTrackingProject();
    }, [handleGetTrackingProject])

    useEffect(() => {
        handleGetProjectStatus()
    }, [idType])

    return (
        <styles.ContainerHome>
            {isLoading === true && <Loading />}
            <Navbar />
            <styles.MainContainer>
                <Header />
                <styles.Content>
                    <section>
                        <Typography className='text-primary' variant='h4'>
                            {t("ติดตามสถานะโครงการ")}
                        </Typography>
                    </section>
                    {/* ROW 1 */}
                    <FilterBox className='grid grid-cols-10 gap-1 mt-8'>
                        <article className='col-span-10 md:col-span-5 lg:col-span-2'>
                            <InputTextField
                                onchange={handleChangeSearch}
                                headingNormal
                                heading='ค้นหาตามชื่อโครงการ'
                            />
                        </article>
                        <article className='col-span-10 md:col-span-5 lg:col-span-2'>
                            <SearchAutocompleteSelect
                                headingNormal
                                heading={t("หน่วยงาน")}
                                labelId="label-agency"
                                idKey="idDepartment"
                                value={idDepartment}
                                fetchOptions={(condition) => DepartMentApi.getDepartments(condition)}
                                getOptionLabel={(option) => option?.departmentName}
                                statusKey="departmentStatus"
                                onChange={(id) => {
                                    dispatch(setPageTrackingStore(1));
                                    setIdDepartment(id)
                                }}
                            />
                        </article>

                        <article className='col-span-10 md:col-span-5 lg:col-span-2'>
                            <SearchAutocompleteSelect
                                headingNormal
                                heading={t("ปีงบประมาณ")}
                                labelId="label-fiscal-year"
                                idKey="idFiscalYear"
                                value={idFiscalYear}
                                serverSearch={false}
                                fetchOptions={(condition) => FiscalYearApi.getFiscalYear(condition)}
                                getOptionLabel={(option) => String(option?.fiscalYear ?? '')}
                                statusKey="fiscalYearStatus"
                                onChange={(id) => {
                                    dispatch(setPageTrackingStore(1));
                                    setIdFiscalYear(id)
                                    setIdStrategy(0)
                                    setIdTactics(0)
                                    setIdClusters(0)
                                    setIdType(0)
                                    setIdStatus(0)
                                }}
                            />
                        </article>
                        <article className='col-span-10 md:col-span-5 lg:col-span-2'>
                            <SearchAutocompleteSelect
                                headingNormal
                                heading={t("ยุทธศาสตร์")}
                                labelId="label-strategic"
                                idKey="idStrategy"
                                value={idStrategy}
                                params={{ idFiscalYear: idFiscalYear }}
                                fetchOptions={(condition) => StrategyApi.getStrategy(condition)}
                                getOptionLabel={(option) => option?.strategyName}
                                statusKey="strategyStatus"
                                onChange={(id) => {
                                    dispatch(setPageTrackingStore(1));
                                    setIdStrategy(id)
                                    setIdTactics(0)
                                }}
                            />
                        </article>
                        <article className='col-span-10 md:col-span-5 lg:col-span-2'>
                            <SearchAutocompleteSelect
                                headingNormal
                                heading={t("กลยุทธ์")}
                                labelId="label-tactics"
                                idKey="idTactics"
                                value={idTactics}
                                params={{ idStrategy: idStrategy }}
                                fetchOptions={(condition) => TacticsApi.getTactics(condition)}
                                getOptionLabel={(option) => option?.tacticsName}
                                statusKey="tacticsStatus"
                                onChange={(id) => {
                                    dispatch(setPageTrackingStore(1));
                                    setIdTactics(id)
                                }}
                            />
                        </article>
                    </FilterBox>

                    {/* ROW 2 */}
                    <FilterBox className='grid grid-cols-10 mt-1 gap-1'>
                        <article className='col-span-10 md:col-span-5 lg:col-span-2'>
                            <SearchAutocompleteSelect
                                headingNormal
                                heading={t("แผนงาน")}
                                labelId="label-plan"
                                idKey="idPlan"
                                value={idPlan}
                                fetchOptions={(condition) => PlanApi.getPlans(condition)}
                                getOptionLabel={(option) => option?.planName}
                                statusKey="planStatus"
                                onChange={(id) => {
                                    dispatch(setPageTrackingStore(1));
                                    setIdPlan(id)
                                }}
                            />
                        </article>
                        <article className='col-span-10 md:col-span-5 lg:col-span-2'>
                            <SearchAutocompleteSelect
                                headingNormal
                                heading={t("ประเภทกลุ่มภารกิจ (Clusters)")}
                                labelId="label-typeOfMissionGroup"
                                idKey="idClusters"
                                value={idClusters}
                                params={{ idFiscalYear: idFiscalYear }}
                                fetchOptions={(condition) => ClustersApi.getClusters(condition)}
                                getOptionLabel={(option) => option?.clustersName}
                                statusKey="clustersStatus"
                                onChange={(id) => {
                                    dispatch(setPageTrackingStore(1));
                                    setIdClusters(id)
                                }}
                            />
                        </article>
                        <article className='col-span-10 md:col-span-5 lg:col-span-2'>
                            <SearchAutocompleteSelect
                                headingNormal
                                heading={t("แหล่งที่มางบประมาณ")}
                                labelId="label-budget"
                                idKey="idBudget"
                                value={idBudget}
                                fetchOptions={(condition) => BudgetApi.getBudgets(condition)}
                                getOptionLabel={(option) => option?.budgetName}
                                statusKey="budgetStatus"
                                onChange={(id) => {
                                    dispatch(setPageTrackingStore(1));
                                    setIdBudget(id)
                                }}
                            />
                        </article>
                        <article className='col-span-10 md:col-span-5 lg:col-span-2'>
                            <SearchAutocompleteSelect
                                headingNormal
                                heading={t("ประเภทโครงการ")}
                                labelId="label-typeProject"
                                idKey="idType"
                                value={idType}
                                params={{ idFiscalYear: idFiscalYear }}
                                fetchOptions={(condition) => TypesApi.getType(condition)}
                                getOptionLabel={(option) => option?.typeName}
                                statusKey="typeStatus"
                                onChange={(id) => {
                                    dispatch(setPageTrackingStore(1));
                                    setIdType(id)
                                    setIdStatus(0)
                                }}
                            />
                        </article>
                        <article className='col-span-10 md:col-span-5 lg:col-span-2'>
                            <FilterSelect
                                disabled={idType === 0}
                                headingNormal
                                heading={t("สถานะโครงการ")}
                                renderValue={() => idStatus === 0 ? "ทั้งหมด" : projectStatus?.find((list: any) => list?.idStatus === idStatus)?.projectStatusName}
                                label={t('')}
                                selectId="select-typeOfMissionGroup"
                                value={idStatus}
                                labelId="label-typeOfMissionGroup"
                                onchange={(event) => {
                                    const value = event.target.value
                                    value && setIdStatus(Number(value))
                                }}
                                options={[
                                    <MenuItem onClick={() => setIdStatus(0)} value={0}>{"ทั้งหมด"}</MenuItem>,
                                    projectStatus && projectStatus?.map((list: any, index: number) => (
                                        <MenuItem key={list?.idStatus} value={list?.idStatus}>
                                            {`${index + 1}.${list?.projectStatusName}`}
                                        </MenuItem>
                                    ))]}
                            />
                        </article>
                    </FilterBox>
                    {/* ROW 3 */}
                    <FilterBox className='mt-1'>
                        <article className='col-span-12 flex justify-start md:justify-end items-center gap-1'>
                            <span className='w-full max-w-[93px] flex flex-col self-end gap-2'>
                                <MenuDropdown
                                    headingNormal
                                    heading='ส่งออกเอกสาร'
                                    buttonName='ดาวน์โหลด'
                                    menuItems={[
                                        { id: 1, name: "pdf", onClick: () => handleGetTrackingProjectFile('pdf') },
                                        { id: 2, name: 'excel', onClick: () => handleGetTrackingProjectFile('excel') }
                                    ]}
                                />
                            </span>
                        </article>
                    </FilterBox>

                    {/* TABLE */}
                    <FilterBox className='mt-8'>
                        {tracking && (
                            <TableCustom
                                tableFixedWidth
                                tableMinWidth={1440}
                                page={pageTrackingStore}
                                pageLimit={pageLimitTrackingStore}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalPage}
                                rowsData={tracking.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => dispatch(setPageTrackingLimitStore(value))}
                                setPage={(value: number) => dispatch(setPageTrackingStore(value))}
                            />
                        )}
                    </FilterBox>
                </styles.Content>
            </styles.MainContainer>

        </styles.ContainerHome>
    )
}

export default TrackProjectStatus
